import { extractNumber } from '@cred/shared/utils'
import config from 'config'
import querystring from 'querystring'
import { footerDisclosure } from 'credit-card/card-table/App'
import get from 'lodash.get'

const creditCardFilters = {
    featured: 'featured cards',
    rewards: 'rewards cards',
    'balance-transfer': 'balance transfer cards',
    'zero-percent': 'zero percent cards',
    secured: 'secured cards',
    student: 'student cards',
    'low-interest': 'low interest cards',
  },

  creditScoreRange = {
    850: '750+',
    749: '700-749',
    699: '640-699',
    639: '<640',
  },

  formatRole = role => {
    switch (role) {
      case 'borrower':
        return 'Student'
      case 'cosigner':
        return 'Co-signer'
      default:
        return role
    }
  },

  generateFilterText = (filterValues, vertical) => {
    switch (vertical) {
      case 'credit-cards':
        return `I'm looking for ${creditCardFilters[filterValues.categoryFilter]}`
      case 'inschool':
        return `I am a ${formatRole(filterValues.role)} looking for a ${filterValues.loanAmount} student loan`
      case 'high-yield-savings':
        return `${filterValues.balanceAmount} Balance amount`
      default:
        return `${filterValues.loanAmount} loan amount and ${creditScoreRange[filterValues.creditScoreApprox]} credit score`
    }
  },

  generateUpdate = (formFilterValues, setFilterValues, closeModalFunc) => () => {
    setFilterValues(formFilterValues.values)
    closeModalFunc()
  },

  getFilteredLenders = (lenders, creditScore, loanAmount) => lenders
    .filter(lender => !creditScore || lender.minCreditScore <= creditScore)
    .filter(lender => !loanAmount || (lender.minAmount <= loanAmount
    && (!lender.maxAmount || lender.maxAmount >= loanAmount))),

  resetFilters = (setFilterValues, initialFormValues) => () => {
    setFilterValues(initialFormValues)
  },

  getCreditScore = (value) => parseInt(value, 10),

  getLoanAmount = (value) => extractNumber(value),
  hasPagination = (variation) => (variation !== 'full'),

  getPageStats = (variation, lenders, page, LENDER_PER_PAGE) => {
    const withPagination = hasPagination(variation),
      pageCount = Math.ceil(lenders.length / LENDER_PER_PAGE),
      pageFrom = page * LENDER_PER_PAGE,
      pageTo = withPagination ? page * LENDER_PER_PAGE + LENDER_PER_PAGE : lenders.length,
      showPagination = withPagination && pageCount > 1

    return { pageCount, pageFrom, pageTo, showPagination }
  },

  getCtaPath = (vertical, theme) => {
    switch (vertical) {
      case 'inschool':
        const dotDashThemes = ['investopedia1', 'thebalance1']
        return dotDashThemes.includes(theme)
          ? 'student-loans'
          : 'private-student-loans/get-started'
      default:
        return ''
    }
  },

  getCtaUrl = (vertical, theme, utms) => {
    const params = {
        utm_source: utms.utm_source,
        utm_medium: utms.utm_medium,
        utm_campaign: utms.utm_campaign,
        utm_content: utms.utm_content,
        credclid: utms.credclid,
        renderId: utms.renderId,
      },
      path = getCtaPath(vertical, theme)

    return `${config.credibleRoot}/${path}?${querystring.encode(params)}`
  },

  getFooterDisclosure = (vertical) => {
    if (vertical === 'credit-cards') {
      return footerDisclosure
    }
  },

  // This convenience method uses lodash's get and tries to key into
  // widgetContext using array keys. widgetContext's structure is
  // defined in WidgetApp.js prop types. If any errors occur, defaults to last
  // argument ({})
  getPartnerDefaultFilterValues = (widgetContext, vertical) => (
    get(widgetContext, ['options', 'multiVertical', 'defaultFilters', vertical], {})
  )

const getMMMDDFormat = (dateArr, months) => `${months[parseInt(dateArr[1], 10) - 1].slice(0, 3)} ${parseInt(dateArr[2], 10)}, ${parseInt(dateArr[0], 10)}`

export {
  formatRole,
  generateFilterText,
  generateUpdate,
  getFilteredLenders,
  getFooterDisclosure,
  resetFilters,
  getCreditScore,
  getLoanAmount,
  hasPagination,
  getMMMDDFormat,
  getPageStats,
  getCtaPath,
  getCtaUrl,
  getPartnerDefaultFilterValues,
}
